var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoReduzida(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 406 400"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M395.3 162.1H203v75.8h114c-15.9 47.8-60.9 82.2-114 82.2-66.4 0-120.2-53.8-120.2-120.2S136.6 79.8 203 79.8c24.8 0 47.7 7.5 66.9 20.3l42-63.1C280.7 16.2 243.3 4 203 4 94.7 4 7 91.7 7 200c0 108.2 87.8 196 196 196s196-87.8 196-196c0-13-1.3-25.7-3.7-37.9",
    fill: "#fff"
  })));
}
export default SvgLogoReduzida;